var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedIncidentsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1553_22301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71007 0 0 4.48578 0 10C0 15.5142 4.71007 20 10.5 20C16.2899 20 21 15.5142 21 10C21 4.48578 16.2899 0 10.5 0Z",
    fill: "#9BA098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8217 7.88074L10.1342 13.2973C9.96356 13.4598 9.73958 13.5416 9.51559 13.5416C9.29161 13.5416 9.06763 13.4598 8.897 13.2973L6.0533 10.589C5.71107 10.2632 5.71107 9.73651 6.0533 9.41074C6.39536 9.08481 6.94827 9.08481 7.2905 9.41074L9.51559 11.5299L14.5845 6.70245C14.9266 6.37653 15.4795 6.37653 15.8217 6.70245C16.1638 7.02823 16.1638 7.55481 15.8217 7.88074Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1553_22301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedIncidentsIcon);
export default __webpack_public_path__ + "static/media/closedIncidentsIcon.f991c883b97e5697fffb32d3c053e92b.svg";
export { ForwardRef as ReactComponent };